import { useMutation } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

interface Parameter {
  body: {
    company_id: string
    pepper_doc_id: string
  }
}

type Response = {
  brief_id: string
}

export async function createBrief({ body }: Parameter) {
  try {
    const response = await axios.post('/briefs', body)
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useCreateBrief() {
  return useMutation({
    mutationKey: ['brief'],
    mutationFn: createBrief
  })
}
